import { testimonials } from '@/mocks/campaigns';
import useSectionAnimation from '@/hooks/useSectionAnimation';

const trustFeatures = [
  {
    icon: 'ri-shield-check-line',
    title: 'تحقق من الهوية',
    desc: 'نتحقق من هوية كل منشئ حملة عبر الهوية الوطنية أو الإقامة',
    color: 'text-emerald-600',
  },
  {
    icon: 'ri-bank-line',
    title: 'حسابات بنكية موثقة',
    desc: 'جميع الحسابات البنكية مرتبطة بهوية حقيقية ومتحقق منها',
    color: 'text-emerald-600',
  },
  {
    icon: 'ri-file-shield-2-line',
    title: 'ترخيص الجمعيات',
    desc: 'الجمعيات الخيرية تحتاج ترخيصاً رسمياً قبل إطلاق أي حملة',
    color: 'text-emerald-600',
  },
  {
    icon: 'ri-eye-line',
    title: 'شفافية كاملة',
    desc: 'كل ريال يُجمع ويُصرف موثق ومتاح للداعمين للاطلاع عليه',
    color: 'text-emerald-600',
  },
];

const TrustSection = () => {
  const { ref, fadeUp, stagger } = useSectionAnimation({ threshold: 0.08 });

  return (
    <section ref={ref} className="py-20 bg-stone-50" dir="rtl">
      <div className="max-w-7xl mx-auto px-8 md:px-12">
        {/* Trust Features */}
        <div className="text-center mb-14" style={fadeUp}>
          <span className="text-emerald-600 text-sm font-semibold tracking-wide uppercase">نظام الثقة</span>
          <h2 className="text-2xl md:text-4xl font-black text-stone-800 mt-2">ثقتك أمانة عندنا</h2>
          <p className="text-stone-500 mt-3 max-w-lg mx-auto text-sm">
            نضع الشفافية والأمان في قلب كل ما نفعله
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-20">
          {trustFeatures.map((f, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 border border-stone-100" style={stagger(i, 90)}>
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-50 mb-4">
                <i className={`${f.icon} text-xl ${f.color}`}></i>
              </div>
              <h3 className="font-bold text-stone-800 mb-2 text-sm">{f.title}</h3>
              <p className="text-stone-500 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="text-center mb-10" style={fadeUp}>
          <h2 className="text-xl md:text-3xl font-black text-stone-800">ماذا يقول مجتمعنا</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={t.id} className="bg-white rounded-2xl p-6 border border-stone-100" style={stagger(i, 110)}>
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <i key={idx} className="ri-star-fill text-amber-400 text-sm"></i>
                ))}
              </div>
              <p className="text-stone-600 text-sm leading-relaxed mb-5">"{t.text}"</p>
              <div className="flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover object-top" />
                <div>
                  <div className="font-bold text-stone-800 text-sm">{t.name}</div>
                  <div className="text-stone-400 text-xs">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
